import { Badge } from './Badge';
import { statusColor } from '@/lib/color';
import type { OperationalStatus } from '@/types';

export function StatusBadge({ status }: { status: OperationalStatus }) {
  return <Badge color={statusColor(status)}>{status.replace(/_/g, ' ')}</Badge>;
}
